import $ from 'jquery';
import { isDevelopment } from '@mockup/func/globals/environment';
import '@mockup/func/globals/App.util';
import { App } from './App';
import { emit } from 'process';

export const lightbox = {
    init: function () {
        $(document).on('click', 'a.video', function () {
            if (isDevelopment) {
                var Cookiebot = {
                    consent: {
                        marketing: true
                    }
                };
            }

            if (!(window.Cookiebot && window.Cookiebot.consent.marketing)) {
                window.Cookiebot.renew();
                return false;
            }

            if (navigator.userAgent.match(/iPhone/)) {
                $(this).append('<iframe data-cookieconsent="marketing" width="100%" height="100%" data-src="' + $(this).attr('href') + '" frameborder="0" allowfullscreen></iframe>');
            }
            // GOOGLE ANALYTIS CUSTOM EVENET
            if (typeof window.ga === 'function') {
                window.ga('send', 'event', 'video', 'play', $(this).attr('href'));
            }

            if (navigator.userAgent.match(/iPhone/)) {
                return false;
            } else if (window.Cookiebot && window.Cookiebot.consent.marketing) {
                $.fancybox({
                    'padding': 0,
                    'width': 1280,
                    'height': 720,
                    'href': $(this).attr('href'),
                    'type': 'iframe',
                    iframe: {
                        preload: false
                    }
                });
                return false;
            }
        });

        $(document).on('click', '.lightbox', function () {
            const opt = opt;
            $.fancybox.open($(this), lightbox.options(opt, {
                padding: 10
            }));
        });

        $(document).on('click', '.lightbox-iframe', function () {
            const opt = $(this).data();
            $.fancybox.open($(this), lightbox.options(opt, {
                width: '75%',
                height: '75%',
                padding: 10,
                type: 'iframe',
                iframe: {
                    scrolling: 'auto',
                    preload: true
                },
                autoSize: false
            }));
        });

        $(document).on('click', '.lightbox-video', function () {

            const opt = $(this).data();
            $.fancybox.open($(this), lightbox.options(opt, {
                width: '75%',
                height: '50vh',
                padding: 0,
                type: 'iframe',
                iframe: {
                    scrolling: 'auto',
                    preload: true
                },
                autoSize: true
            }));
        });

        $(document).on('click', '.lightbox-ajax', function () {
            const opt = $(this).data();
            $.fancybox.open($(this), lightbox.options(opt, {
                width: 500,
                height: 500,
                padding: 10,
                type: 'ajax',
                autoSize: false
            }));
        });

        $(document).on('click', '.lightbox-inline', function () {
            const opt = $(this).data();
            if ($(this).attr('disabled') === 'disabled') return;
            const opener = this;
            $.fancybox.open($(this), lightbox.options(opt, {
                padding: 20,
                type: 'inline',
                title: false,
                minHeight: 0,
                beforeLoad: function () {
                    var url = this.href;
                    if (!url) {
                        url = $(this).data('href');
                    }

                    var hash = url.substring(url.indexOf('#'));
                    this.href = hash;
                },
                afterClose: function () {
                    if (opener && typeof opener.focus === 'function') {
                        opener.focus();
                    }

                    document.dispatchEvent(new Event('lightbox-inline-close'));
                }
            }));

            App.format.init();
        });

        $(document).on('click', '.fancy-modal-close', function () {
            $.fancybox.close();
        });
    },
    options: function (dataOpt, defaults) {
        var data = $.extend({}, defaults, dataOpt);
        return $.extend({}, defaults, dataOpt);
    }
};

export default lightbox;

App.Util.lightbox = lightbox;
